import { GeneratedJobType, Group } from './types';
import { Message } from './types';

export const getGroupColor = (index: number): string => {
    const groupColors = [
        '#7AACE8',
        '#ACE4EF',
        '#FDCF68',
        '#A9C9D2',

        '#A6C9F0',
        '#B3EDF8',
        '#FEE09E',
        '#C3DAE0',

        '#D3E3F7',
        '#D0F4FA',
        '#FEECC4',
        '#DEEAED',

        '#E8F1FB',
        '#EEFBFD',
        '#FFF7E7',
        '#EDF3F5',
    ];
    const normalizedIndex = index % groupColors.length;
    return groupColors[normalizedIndex];
};

export const createGroupsFromMessages = (item: GeneratedJobType): Group[] => {
    const groups: Group[] = [];
    const messagesWithoutHistory = item.messages.filter((message) => !message.prev_message_id);
    const messagesWithHistory = item.messages.filter((message) => message.prev_message_id);

    messagesWithoutHistory?.forEach((message) => {
        groups.push({
            id: message.version.major,
            color: getGroupColor(groups.length),
            messagesIds: [message.message_id],
            isCollapsed: !!item.collapsedGroups?.includes(message.version.major),
        });
    });

    messagesWithHistory?.forEach((message) => {
        const messageAncestor = findMessageAncestor(message, item.messages);
        const group = groups.find((group) => group.id === messageAncestor?.version.major)!;
        group.messagesIds.push(message.message_id);
    });

    return groups;
};

export const findMessageAncestor = (message: Message, messages: Message[]) => {
    let previousMessage = messages.find((m) => m.message_id === message.prev_message_id);
    while (previousMessage?.prev_message_id) {
        previousMessage = messages.find((m) => m.message_id === previousMessage?.prev_message_id);
    }
    return previousMessage;
};

export const findGroup = (groups: Group[], messageId: string) => {
    return groups.find((g) => g.messagesIds.includes(messageId));
};
